import { useI18n } from "@wojo/localization";
import { FormRadioGroup, Text } from "@wojo/ui";
import currency from "currency.js";
import { getCurrency } from "../../../../hooks";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import { QuoteFlightsModal } from "./QuoteFlightsModal";
import styles from "./TripBuilderQuoteStep.module.scss";

export const QuoteGroupsRequiredFlightPicker: React.FC = () => {
    const { productPage } = useI18n("productPage");

    const { formatCurrency } = getCurrency();

    const { draftQuote } = useTripBuilderQuote();
    const departingFlightPackage = draftQuote?.order.trips[0].lineItems.find(
        (lineItem) => lineItem.__typename === "FlightPackageLineItem",
    );

    const flightPrice = draftQuote?.order.trips[0].lineItems
        .filter((lineItem) => lineItem.__typename === "FlightPackageLineItem")
        .reduce((acc, lineItem) => {
            return acc.add(lineItem.price.value);
        }, currency(0)).value;

    const gateway =
        departingFlightPackage?.__typename === "FlightPackageLineItem" &&
        departingFlightPackage.departureGateway;
    if (!gateway) {
        return null;
    }

    return (
        <div className={styles["form-field"]}>
            <FormRadioGroup
                title={
                    <Text.Body variant="2" emphasis="2" tag="span">
                        {productPage.tripBuilder.quote.flights.heading.l()}
                    </Text.Body>
                }
                validation={{
                    required:
                        productPage.tripBuilder.quote.flights.errorRequiredAirport.l(),
                }}
                description={<QuoteFlightsModal />}
                name="flightOption"
                detailPosition="right"
                items={[
                    {
                        label: productPage.tripBuilder.quote.flights.withFlightsSelectedLabel.l(
                            {
                                cityName: gateway.internalCityName || "",
                                cityCode: gateway.stateCode || "",
                            },
                        ),
                        labelDetail:
                            typeof flightPrice === "number"
                                ? formatCurrency(flightPrice)
                                : "",
                        moreDetails: (
                            <Text.Body>
                                {productPage.tripBuilder.quote.flights.requiredDetails.l(
                                    {
                                        cityName:
                                            gateway.internalCityName || "",
                                        cityCode: gateway.stateCode || "",
                                    },
                                )}
                            </Text.Body>
                        ),
                        value: "yesFlights",
                    },
                ]}
            />
        </div>
    );
};
